import { useSessionBootstrap } from '@entities/session'
import { CrowdAvatarsLayer } from '@features/crowd-avatars'
import { HealthIndicator } from '@features/health-indicator'
import { useWsConnection } from '@features/ws-connection'
import { logOverlayEnvironment } from '@shared/lib/runtime/logEnvironment'
import { EffectsLayer } from '@widgets/effects-layer'
import { GamesLayer } from '@widgets/games-layer/GamesLayer'
import { ZoneLayoutManager } from '@widgets/zone-layout'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

export function OverlayPage() {
  const { streamerId = 'unknown' } = useParams<{ streamerId: string }>()
  const isDemo = streamerId === 'demo'

  useEffect(() => {
    logOverlayEnvironment()
  }, [])

  const sessionStatus = useSessionBootstrap()
  useWsConnection({ streamerId, enabled: !isDemo && sessionStatus !== 'pending' })

  return (
    <div
      style={{
        background: 'transparent',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
      }}
      aria-label='OBS Stream Overlay'
    >
      {!isDemo ? (
        <GamesLayer channelId={streamerId} enabled={sessionStatus !== 'pending'} />
      ) : null}
      <CrowdAvatarsLayer enabled />
      {/* ZoneLayoutManager wraps EffectsLayer only — poll/drawing/soundboard zones.
          Games / crowd / health stay outside the zone provider. */}
      <ZoneLayoutManager>
        <EffectsLayer />
      </ZoneLayoutManager>
      {!isDemo ? <HealthIndicator /> : null}
    </div>
  )
}
